import Link from 'next/link';
import Chevron from '../../svg/ChevronLeft15.svg';
import styles from './Link.module.css';

const BackLink = ({ to, color = 'dark' }: { to?: 'games' | 'prizes', color?: 'light' | 'dark' }) => {
  return (
    <Link href={`/token-town${to ? `?tab=${to}` : ''}`}>
      <div className={`${styles.linkContainer} ${styles.extraPadding} ${color === 'light' ? styles.light : styles.dark}`}>
        <Chevron />

        <p className={styles.linkLabel}>
          BACK TO TOKEN TOWN
        </p>
      </div>
    </Link>
  );
};

export default BackLink;
